import type {
  FormattedResolutions,
  RawResolutionData
} from '@library/types/resolutions/resolutionsList';

const mockResolutions: FormattedResolutions = {
  '105': {
    adminName: 'Justin Hillard',
    adminEmail: 'justin.hillard@prizepicks.com',
    id: '105',
    createdAtDate: 'March 1, 2025',
    createdAtTime: '12:00 PM',
    updatedAtDate: 'March 1, 2025',
    updatedAtTime: '12:00 PM',
    reason: 'Projection left up past start time',
    status: 'completed',
    type: 'Refund'
  },
  '204': {
    adminName: 'Jeremy Gismondi',
    adminEmail: 'jeremy.gismondi@prizepicks.com',
    createdAtDate: 'March 1, 2025',
    createdAtTime: '12:00 PM',
    updatedAtDate: 'March 1, 2025',
    updatedAtTime: '12:00 PM',
    id: '204',
    reason: 'Projection left up past start time',
    status: 'draft',
    type: 'DNP'
  },
  '306': {
    adminName: 'Blake Stephenson',
    adminEmail: 'blake.stephenson@prizepicks.com',
    createdAtDate: 'March 1, 2025',
    createdAtTime: '12:00 PM',
    updatedAtDate: 'March 1, 2025',
    updatedAtTime: '12:00 PM',
    id: '306',
    reason: 'Player DNP',
    status: 'processing',
    type: 'DNP'
  },
  '405': {
    adminName: 'Rafael Villardo',
    adminEmail: 'rafael.villardo@prizepicks.com',
    createdAtDate: 'March 1, 2025',
    createdAtTime: '12:00 PM',
    updatedAtDate: 'March 1, 2025',
    updatedAtTime: '12:00 PM',
    id: '405',
    reason: 'Projection left up past start time',
    status: 'discarded',
    type: 'Refund'
  },
  '501': {
    adminName: 'James Bond',
    adminEmail: 'james.bond@prizepicks.com',
    createdAtDate: 'March 1, 2025',
    createdAtTime: '12:00 PM',
    updatedAtDate: 'March 1, 2025',
    updatedAtTime: '12:00 PM',
    id: '501',
    reason: 'Projection left up past start time',
    status: 'unrecoverable_error',
    type: 'Refund'
  }
};

export const resolutionsData: RawResolutionData = {
  data: mockResolutions,
  currentPage: 1,
  totalPages: 1
};
